export default __webpack_public_path__ + "static/media/GChurchill.1c001f4a.png";